import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { LIVE_SCORES } from '../../../routes/paths';
import EventDetails from '../EventDetails';
import Events from '../Events';

export const LiveScores = () => (
  <Switch>
    <Route
      path={`${LIVE_SCORES}/:day/:eventId`}
      component={EventDetails}
    />
    <Route
      component={Events}
    />
  </Switch>
);

export default LiveScores;
